
export default {
  advanced_filters: {
    key: 'app_advanced_filters'
  }
}
